import ImgAi from '../assets/files/ai.png';
import ImgDefault from '../assets/files/default.png';
import ImgDocx from '../assets/files/docx.png';
import ImgPdf from '../assets/files/pdf.png';
import ImgPptx from '../assets/files/pptx.png';
import ImgPsd from '../assets/files/psd.png';
import ImgSvg from '../assets/files/svg.png';
import ImgTtf from '../assets/files/ttf.png';
import ImgTxt from '../assets/files/txt.png';
import ImgXlsx from '../assets/files/xlsx.png';
import ImgZip from '../assets/files/zip.png';
import ImgMp3 from '../assets/files/mp3.png';
import ImgMp4 from '../assets/files/mp4.png';
import ImgGif from '../assets/files/gif.png';
import utils from 'styles/utils';
import { getFileExtensionFromMimetype } from 'jamespot-user-api';

function getFile(color: string, uri: string) {
    return {
        path: uri,
        colors: {
            primary: color,
            light: utils.getLightShade(color, 0.6),
            dark: utils.getDarkShade(color, 0.3),
        },
    };
}

export function fileAvatar(mimetype: string) {
    const ext = getFileExtensionFromMimetype(mimetype);
    switch (ext) {
        case 'png':
        case 'jpg':
        case 'jpeg':
            return {
                path: ImgDefault,
                colors: {
                    primary: '#F8F8FF',
                    light: '#F8F8FF',
                    dark: '#F8F8FF',
                },
                ext,
            };
        case 'gif':
            return { ...getFile('#0f413a', ImgGif), ext };
        case 'docx':
        case 'odt':
            return { ...getFile('#0263D1', ImgDocx), ext };
        case 'xlsx':
        case 'csv':
            return { ...getFile('#00733B', ImgXlsx), ext };
        case 'pptx':
            return { ...getFile('#E03303', ImgPptx), ext };
        case 'pdf':
            return { ...getFile('#CC2353', ImgPdf), ext };
        case 'zip':
            return { ...getFile('#566DC6', ImgZip), ext };
        case 'mpeg':
        case 'mp3':
            return { ...getFile('#8762D7', ImgMp3), ext };
        case 'mp4':
            return { ...getFile('#218273', ImgMp4), ext };
        case 'svg':
            return { ...getFile('#EA80CA', ImgSvg), ext };
        case 'psd':
            return { ...getFile('#4DA7E6', ImgPsd), ext };
        case 'otf':
        case 'ttf':
            return { ...getFile('#131E4B', ImgTtf), ext };
        case 'ai':
            return { ...getFile('#ED8200', ImgAi), ext };
        case 'txt':
            return { ...getFile('#ED8200', ImgTxt), ext };
        default:
            return { ...getFile('#7EDDCF', ImgDefault), ext };
    }
}

const roundTwoDecimals = (n: number) => Math.round(n * 100) / 100;
export const formatFileSize = (size: number) => {
    if (size > 1_000_000_000) {
        return roundTwoDecimals(size / 1_000_000_000) + ' Go';
    } else if (size > 1_000_000) {
        return roundTwoDecimals(size / 1_000_000) + ' Mo';
    } else if (size > 1_000) {
        return roundTwoDecimals(size / 1000) + ' Ko';
    } else {
        return roundTwoDecimals(size) + ' o';
    }
};
